import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaTrophy, FaUsers, FaCalendarCheck, FaMedal, FaArrowRight } from 'react-icons/fa';
import './About.css';
import { Helmet } from 'react-helmet';

const BeginnerTraining1 = () => {

    return (
        <>
            <Helmet>
                <title>Beginner Training</title>
            </Helmet>
            <div className="about-page">
                <div className="page-header">
                    <div className="container">
                        <h1>Beginner Training</h1>
                        <div className="breadcrumb">
                            <Link to="/">Home</Link>
                            <span>/</span>
                            <span>Beginner Training</span>
                        </div>
                    </div>
                </div>

                <section className="about-intro section">
                    <div className="container">
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <span className="section-subtitle">Imperial Badminton Academy</span>
                                <h2>Welcome to Imperial Badminton Academy</h2>
                                <p>
                                    Starting badminton the right way is essential for long-term success and enjoyment of the sport. At Imperial Badminton Academy, our Beginner Training Program is carefully designed to introduce new players to badminton in a structured, safe, and motivating environment. This program focuses on building strong fundamentals while developing confidence, coordination, and a love for the game.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="intro-img-main">
                                    <img src="/img/Beginner Training.jpg" alt="Academy Training" />
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Who Is This Program For?</h3>
                                <p>
                                    Children starting badminton for the first time
                                    <br />
                                    Teenagers and adults with little or no prior experience
                                    <br></br>
                                    Players looking to learn correct basics and techniques
                                    <br></br>
                                    Fitness enthusiasts who want to learn badminton professionally
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Training Approach</h3>
                                    <p>The beginner program follows a step-by-step learning method that ensures players understand the basics thoroughly before progressing. Our experienced coaches focus on correct techniques, simple drills, and gradual skill development, allowing beginners to learn at a comfortable pace.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Core Areas of Training</h3>
                                <p>
                                    Forehand and backhand
                                    <br></br>
                                    Basic serves
                                    <br></br>
                                    Net shots
                                    <br></br>
                                    Simple clears
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Footwork & Court Movement</h3>
                                    <p>Proper footwork is introduced through simple drills that improve balance, coordination, and court awareness. Beginners learn how to move efficiently on the court, which is crucial for control and injury prevention.</p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Rules & Game Understanding</h3>
                                <p>
                                    Understanding the rules of badminton is an important part of the learning process. Coaches explain scoring systems, court boundaries, service rules, and basic match etiquette, helping beginners feel comfortable during practice games.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Fitness & Coordination</h3>
                                    <p>Flexibility
                                        <br></br>
                                        Stamina
                                        <br></br>
                                        Hand-eye coordination
                                        <br></br>
                                        Overall body balance</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Safety & Supervision</h3>
                                    <p>Player safety is our priority. All beginner sessions are conducted under close supervision by trained coaches. Training intensity is adjusted according to age and physical ability to ensure a safe and enjoyable learning experience.</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Confidence Building & Motivation</h3>
                                    <p>Our beginner program emphasizes positive reinforcement and encouragement. Coaches motivate players, correct mistakes patiently, and help beginners build confidence on the court. This approach ensures players remain enthusiastic and committed to learning.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Progress Evaluation</h3>
                                    <p>Beginners are regularly assessed on their skill development and comfort level. Once players demonstrate improved fundamentals and confidence, they are gradually guided toward intermediate training programs.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Benefits of Beginner Training at Imperial Badminton Academy</h3>
                                    <p>Strong foundation in badminton basics
                                        <br></br>
                                        Correct techniques from day one
                                        <br></br>
                                        Improved fitness and coordination
                                        <br></br>
                                        Increased confidence and discipline
                                        <br></br>
                                        Smooth transition to higher-level training
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default BeginnerTraining1;
